import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { BaseEntite } from '../../../../../common/src/entities';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { Popout } from './Popout';
import { ValueType } from 'react-select';
import { affichageElementDefautBase } from '../Thematiques/ChampMultipleDnd';

export interface ChampSelectEntiteProps<T extends BaseEntite> {
    id: string;
    label: string;
    titreBouton: string;
    items: T[];
    onChange: (item: T | null) => void;
    affichageItem: (item: T) => ReactNode;
    keyEntite: string;
    labelCol: number;
    getItemName?: (item: T) => string;
    getItemLabel?: (item: T) => string;
    initialValue?: T;
}

export default function ChampSelectEntite<T extends BaseEntite>(props: ChampSelectEntiteProps<T>): ReactElement {
    const {
        id,
        label,
        titreBouton,
        items,
        onChange,
        affichageItem,
        keyEntite,
        labelCol,
        getItemName,
        getItemLabel,
        initialValue,
    } = props;
    const [selectedItem, setSelectedItem] = useState<T | null>(initialValue ?? null);

    useEffect(() => {
        setSelectedItem(initialValue ?? null);
    }, [initialValue]);

    const handleChange = (
        value: ValueType<
            {
                label: string;
                name: string;
                id: number;
            },
            false
        >,
    ) => {
        if (value && items) {
            const selected = (items as any[]).find((item) => item.id === value.id);
            if (selected) {
                setSelectedItem(selected);
                onChange(selected);
            }
        }
    };

    const handleRemove = () => {
        setSelectedItem(null);
        onChange(null);
    };

    const cssCardBody: React.CSSProperties = {
        padding: 0,
        minHeight: 30,
        height: '30px',
        fontSize: '14px',
    };

    return (
        <Form.Group>
            <Row>
                <Col xs={labelCol}>{label}</Col>
                <Col>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body style={cssCardBody}>
                                    <div>
                                        <div>
                                            {selectedItem &&
                                                affichageElementDefautBase(
                                                    keyEntite,
                                                    selectedItem,
                                                    null,
                                                    null,
                                                    () =>
                                                        selectedItem
                                                            ? affichageItem(selectedItem)
                                                            : 'Aucun élément sélectionné',
                                                    handleRemove,
                                                    { height: '30px' },
                                                )}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col xs={labelCol}></Col>
                <Col className="pt-2">
                    <Popout
                        id={id}
                        titre={titreBouton}
                        size="sm"
                        options={items.map((item) => ({
                            name: getItemName ? getItemName(item) : item.name,
                            id: item.id,
                            label: getItemLabel ? getItemLabel(item) : item.name,
                        }))}
                        onChange={handleChange}
                        avecUnBouton
                    />
                </Col>
            </Row>
        </Form.Group>
    );
}
